import React from 'react';
import ExploreSidebar from '../components/explore-sidebar';
import Room from '../components/room';
import EntranceAssets from '../svg/Entrance_Assets';
import EntranceDoor from '../svg/Entrance_Door';
import EntranceOverlay from '../components/entrance-overlay';
import '../styles/entrance.css'
import SideMenu from '../components/side-menu';

const Entrance = () => {
    
    const sidebarParagraphs = [
        'You’re standing at the southwest corner of Mutual and Carlton — just a few blocks from Toronto’s queer village.',

'A red-brick, four-story Victorian mansion looms before you. Most nights, it’s home to Club Toronto, a low-end gay men’s bathhouse. But tonight, the Pussy Palace takes over, and cis men are kindly uninvited.',

'The atmosphere is electric — liberatory. Step inside to explore nine rooms, reimagined through first-person memories and present-day references.'
    ];
    
    return (
        <div className='room-wrapper'>
            <SideMenu mobileOnly='true' active=''/>
            <ExploreSidebar
                title='The Entrance'
                descriptions={sidebarParagraphs}
                isEntrance={true}
            />
            <div className='room-container'>
                <Room 
                    id='entrance' 
                    style={{backgroundImage: 'url(/assets/images/explore-hero/Entrance_Illustration.jpg)'}}
                    objects={[
                        {component: <EntranceDoor />, id: 'entrance-door'}
                    ]}
                    decorations={[
                        {component: <EntranceOverlay />, id: 'entrance-overlay'},
                        {component: <EntranceAssets />, id: 'entrance-assets'}
                    ]}
                    ambient='/assets/audio/Entrance_Ambient_Sound.mp3'
                />
                <div className='room-buffer'></div>
            </div>
        </div>
    )
}

export default Entrance;